import _ from 'lodash'
import Serializer from './serializer.js'
import Parser from './parser.js'

export default class Expander {
  constructor (enableCache = false) {
    this.serializer = new Serializer()
    this.parser = new Parser(enableCache)
  }

  expand (formula) {
    if (_.isArray(formula)) {
      return this.expand({
        '&&': formula
      })
    }

    if (_.isPlainObject(formula)) {
      return _.mapValues(formula, f => _.map(f, this.expand.bind(this)))
    }

    if (_.isString(formula)) {
      return this.expandNode(this.parser.parse(formula))
    }

    return formula
  }

  expandNode (node) {
    switch (node?.type) {
      case 'LogicalExpression':
      case 'BinaryExpression':
        return this.expand({
          [node.operator]: [
            this.expandNode(node.left),
            this.expandNode(node.right)
          ]
        })
      case 'ConditionalExpression':
        return `(${this.serializer.serialize(this.expandNode(node.test))} ? ${this.serializer.serialize(this.expandNode(node.consequent))} : ${this.serializer.serialize(this.expandNode(node.alternate))})`
      case 'Task':
        if (node.taskArg) {
          node.taskArg.json = true
        }

        break
    }

    return this.serializer.serializeNode(node)
  }
}
